import { addMessage } from "../../slices/messageSlice"; // 🔁 Redux action to inject messages

/**
 * 🧹 Fetch and synchronize Communication messages from the FHIR server.
 * Promotes any previously pending local messages if they're confirmed in the server response.
 *
 * @param {string} anchorRef - FHIR reference like "Communication/abc123"
 * @param {object} fhirClient - An authorized FHIR client instance
 */
export const promotePending = (anchorRef, fhirClient) => {
  console.log("🔄 Starting promotePending for anchorRef:", anchorRef);

  return async (dispatch, getState) => {
    // 🧯 Defensive guards
    if (!anchorRef) {
      console.log("⚠️ No anchorRef provided to promotePending");
      return;
    }
    if (!fhirClient) {
      console.log("⚠️ No fhirClient provided to promotePending");
      return;
    }

    try {
      // 📡 Query server for all messages linked to the anchor thread
      const response = await fhirClient.request(`Communication?part-of=${anchorRef}`);
      const messages = (response.entry || []).map((e) => e.resource);
      console.log(`📬 Fetched ${messages.length} messages from server for anchorRef ${anchorRef}`);

      const { byId } = getState().messages;

      messages.forEach((msg) => {
        const existingMeta = byId[msg.id]?.meta || {};
        const isPending = existingMeta.isPending;
        const exists = !!byId[msg.id];

        if (isPending) {
          console.log(`✅ Promoting message ${msg.id} from pending → confirmed`);
          dispatch(
            addMessage({
              ...msg,
              meta: {
                ...existingMeta,
                isPending: false // promote to confirmed
              }
            })
          );
        } else if (!exists) {
          console.log(`🆕 New message detected: ${msg.id}`);
          dispatch(
            addMessage({
              ...msg,
              meta: {
                isPending: false // new messages are confirmed
              }
            })
          );
        } else {
          //console.log(`⏭️ Skipping message ${msg.id} (already confirmed)`);
        }
      });
    } catch (err) {
      console.error("💥 promotePending failed:", err);
    }
  };
};
